import '../styles/index.scss';

// import './App';